export const FETCH_ACTIONS = {
    expiredToken: 'dashboard.user_auth.expired_token',
};
